// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"903c5f5f","584":"26542e66","661":"2918fad6","722":"31d6cfe0","819":"903c5f5f"}[chunkId] + ".chunk.css";
};